import { copy } from "angular";
import { IModalScope } from "angular-ui-bootstrap";
import { IIndicator } from "@gtmhub/error-handling";
import { ICollection } from "@webapp/core/core.models";
import { IPlanningSessionConflict, Session } from "@webapp/sessions/models/sessions.model";
import { PlanningSessionService } from "../services/planning-session.service";

export interface IConfirmDeleteSessionScope extends IModalScope {
  indicators: {
    loading?: IIndicator;
  };
  conflicts: ICollection<IPlanningSessionConflict>;
  planningSession: Session;
  showConfirmation: boolean;
  showConflicts: boolean;
}

export class DeletePlanningSessionCtrl {
  public static $inject = ["$scope", "PlanningSessionService", "planningSession"];

  constructor(private $scope: IConfirmDeleteSessionScope, private planningSessionService: PlanningSessionService, private planningSession: Session) {
    this.$scope.indicators = {
      loading: { progress: true },
    };

    this.$scope.planningSession = copy(this.planningSession);
    delete this.$scope.planningSession.parentId;

    this.init();
  }

  private init = (): void => {
    this.planningSessionService.checkForConflictsInSession(this.planningSession, "delete").then(
      (conflicts) => {
        this.$scope.conflicts = conflicts;
        delete this.$scope.indicators.loading;

        if (conflicts.totalCount === 0) {
          this.$scope.showConfirmation = true;
        } else {
          this.$scope.showConflicts = true;
        }
      },
      (error) => (this.$scope.indicators.loading = { error })
    );
  };
}
